export default __webpack_public_path__ + "static/storybanner-842bc4072b5a07d0805b92dbd8e8fc6b.jpg";